export default {
  title: "العملاء",
  subtitle: "إدارة حسابات ومعلومات العملاء",
  banCustomer: "حظر العميل",
  activateCustomer: "تنشيط العميل",
  // Actions
  addNew: "إضافة عميل جديد",
  createCustomer: "إنشاء عميل",
  editCustomer: "تعديل العميل",
  deleteCustomer: "حذف العميل",
  customerDetails: "تفاصيل العميل",
  customerInformation: "معلومات العميل",
  newOrder: "طلب جديد",
  orderType: "نوع الطلب",
  ship4me: "طلب اشحنلي",
  buy4me: "طلب اشتريلي",
  customerOrders: "طلبات العميل",

  orderForm: {
    country: "البلد",
    link: "رابط المنتج",
    options: "خيارات المنتج",
    quantity: "الكمية",
    price: "سعر المنتج",
    actions: "خيارات الأوامر",
    selectCountry: "اختر البلد",
    linkPlaceholder: "رابط المنتج",
    optionsPlaceholder: "تفضيلات أو تعليمات الطلب مثل اللون،الحجم،كوبون خصم",
    pricePlaceholder: "0.00",
    deleteRow: "حذف المنتج",
    addRow: "إضافة منتج",
    submit: "إرسال الطلب"
  },

  ordersTable: {
    orderNumber: "رقم الطلب",
    type: "النوع",
    group: "المجموعة",
    merchant: "التاجر",
    quantity: "الكمية",
    status: "الحالة",
    price: "السعر",
    actions: "خيارات الأوامر",
    viewDetails: "عرض تفاصيل الطلب",
    noOrders: "لا توجد طلبات",
    noOrdersDesc: "لم يقم هذا العميل بتقديم أي طلبات بعد."
  },

  actions: {
    title: "الأوامر",
    back: "رجوع",
    update: "تحديث",
    updating: "جاري التحديث...",
    save: "حفظ",
    saving: "جاري الحفظ...",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    create: "إنشاء",
    creating: "جاري الإنشاء...",
    view: "عرض التفاصيل",
    editProfile: "تعديل ملف العميل",
    editAddress: "تعديل عنوان المستخدم"
  },
  
  // Fields
  fields: {
    name: "اسم العميل",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    address: "سطر العنوان الأول",
    address2: "سطر العنوان الثاني",
    city: "المدينة",
    country: "البلد",
    postalCode: "الرمز البريدي",
    company: "الشركة",
    taxNumber: "الرقم الضريبي",
    customerType: "نوع العميل",
    creditLimit: "حد الائتمان",
    paymentTerms: "شروط الدفع",
    status: "الحالة",
    notes: "ملاحظات",
    password: "كلمة المرور",
    userAddress: "عنوان المستخدم",
    verifiedAt: "تاريخ التوثيق",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث"
  },
  
  // Placeholders
  placeholders: {
    name: "أدخل اسم العميل",
    email: "أدخل البريد الإلكتروني",
    phone: "أدخل رقم الهاتف",
    address: "أدخل سطر العنوان الأول",
    address2: "أدخل سطر العنوان الثاني (اختياري)",
    city: "اختر المدينة",
    country: "اختر البلد",
    postalCode: "أدخل الرمز البريدي",
    company: "أدخل اسم الشركة",
    taxNumber: "أدخل الرقم الضريبي",
    creditLimit: "أدخل حد الائتمان",
    paymentTerms: "أدخل شروط الدفع",
    password: "أدخل كلمة المرور",
    notes: "أدخل ملاحظات إضافية"
  },
  
  // Messages
  messages: {
    createSuccess: "تم إنشاء العميل بنجاح",
    createError: "فشل في إنشاء العميل",
    updateSuccess: "تم تحديث العميل بنجاح",
    updateError: "فشل في تحديث العميل",
    deleteSuccess: "تم حذف العميل بنجاح",
    deleteError: "فشل في حذف العميل",
    deleteConfirm: "هل أنت متأكد من حذف هذا العميل؟",
    statusConfirm: "هل أنت متأكد من {{action}} هذا العميل؟",
    statusSuccess: "تم {{action}} العميل بنجاح",
    statusError: "فشل في تحديث حالة العميل",
    noCustomers: "لا يوجد عملاء",
    loadingCustomers: "جاري تحميل العملاء...",
    loading: "جاري تحميل تفاصيل العميل...",
    fetchError: "فشل في جلب العملاء"
  },
  
  // Validation
  validation: {
    nameRequired: "اسم العميل مطلوب",
    nameMinLength: "اسم العميل يجب أن يكون على الأقل حرفين",
    nameMaxLength: "اسم العميل يجب ألا يتجاوز 100 حرف",
    emailRequired: "البريد الإلكتروني مطلوب",
    emailFormat: "يرجى إدخال بريد إلكتروني صحيح",
    emailInvalid: "يرجى إدخال بريد إلكتروني صحيح",
    phoneRequired: "رقم الهاتف مطلوب",
    phoneFormat: "رقم الهاتف يجب أن يبدأ بـ 7 ويتكون من 10 أرقام",
    phoneInvalid: "رقم الهاتف يجب أن يبدأ بـ 7 ويتكون من 10 أرقام",
    passwordRequired: "كلمة المرور مطلوبة",
    passwordMinLength: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
    passwordComplexity: "يجب أن تحتوي كلمة المرور على حرف كبير وحرف صغير ورقم ورمز خاص",
    passwordTooEasy: "لا يمكن أن تكون كلمة المرور سهلة مثل 123456",
    passwordMatchesPhone: "لا يمكن أن تطابق كلمة المرور رقم الهاتف المحمول المسجل",
    addressRequired: "العنوان مطلوب",
    cityRequired: "المدينة مطلوبة",
    countryRequired: "البلد مطلوب",
    creditLimitMin: "حد الائتمان يجب أن يكون 0 أو أكثر",
    taxNumberFormat: "يرجى إدخال رقم ضريبي صحيح",
    fillAllFields: "يرجى ملء جميع الحقول المطلوبة"
  },
  
  // Table headers
  table: {
    id: "المعرف",
    mailboxNumber: "رقم صندوق البريد",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    company: "الشركة",
    city: "المدينة",
    country: "البلد",
    customerType: "النوع",
    creditLimit: "حد الائتمان",
    status: "الحالة",
    actions: "خيارات الأوامر"
  },
  
  // Status options
  statusOptions: {
    active: "نشط",
    inactive: "غير نشط",
    suspended: "معلق"
  },
  
  // Customer types
  customerTypes: {
    individual: "فردي",
    business: "تجاري",
    corporate: "شركة"
  },
  
  // Breadcrumbs
  breadcrumbs: {
    customers: "العملاء",
    create: "إنشاء عميل",
    edit: "تعديل العميل",
    view: "عرض العميل"
  }
};
